import { render, staticRenderFns } from "./appDate.vue?vue&type=template&id=1faa67ba&"
import script from "./appDate.vue?vue&type=script&lang=js&"
export * from "./appDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports